import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./AdminLayout.css";

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (!user) {
    return null; // Or a loading spinner
  }

  const canManage = user.role === "admin" || user.role === "superadmin";

  return (
    <div className="admin-layout">
      <nav className="admin-nav">
        <div className="nav-brand">
          <h1>78WIN</h1>
        </div>
        <div className="nav-links">
          <NavLink
            to="/customer-management"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Điểm danh
          </NavLink>
          <NavLink
            to="/reward-code"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Mã dự thưởng
          </NavLink>
          {canManage && (
            <NavLink
              to="/top-race"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Đua top
            </NavLink>
          )}
          {canManage && (
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Cài đặt
            </NavLink>
          )}
          {canManage && (
            <NavLink
              to="/user-management"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Hậu đài
            </NavLink>
          )}
          {canManage && (
            <NavLink
              to="/ip-whitelist"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              IP
            </NavLink>
          )}
        </div>
        <button onClick={handleLogout} className="logout-button">
          Đăng xuất ({user.username})
        </button>
      </nav>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
